export default __webpack_public_path__ + "images/logoDesignboom.c46d18c7c977e733ebb6141682a2c9c1.svg"